<template>
  <div id="supportTicketAddNew">
    <vs-prompt name="productSearch" vs-title="Ürün Arama Motoru ( Enter ile arama yapınız )" vs-button-cancel="border" :vs-active.sync="productSearchPopupComputed" :vs-buttons-hidden="true" @vs-close="ChooseOrClose()" @vs-cancel="ChooseOrClose()">
      <template v-if="chosenItem.customerId == null">
        <form @submit.prevent="ItemSearch()">
          <div class="vx-row mb-3" style="flex-wrap: nowrap;">
            <div class="vx-col md:w-1/6 w-full">
              <label class="text-sm"><b>Marka</b></label>
              <v-select @input="ItemSearch()" name="brand" placeholder="Seçiniz" v-model="searchModel.brand" :options="productBrandList" :clearable="true" :reduce="(productBrandList) => productBrandList.brandName" label="brandName">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>

            <div class="vx-col md:w-1/4 w-full">
              <label class="text-sm"><b>Ürün Adı</b></label>
              <vs-input class="w-full" v-model="searchModel.productName" />
            </div>
            <div class="vx-col md:w-1/6 w-full">
              <label class="text-sm"><b>Product Id</b></label>
              <vs-input class="w-full" v-model="searchModel.productId" />
            </div>
            <div class="vx-col md:w-1/12 w-full" style="text-align: left;">
              <vs-radio vs-value="Hardware" vs-name="ProductType" v-model="searchModel.productType" @change="ItemSearch()">Hardware</vs-radio>
              <vs-radio vs-value="Software" vs-name="ProductType" v-model="searchModel.productType" @change="ItemSearch()">Software</vs-radio>
            </div>
            <div class="vx-col md:w-1/6 w-full" style="text-align: left;">
              <vs-radio vs-value="true" vs-name="RequiresSubscription" v-model="searchModel.requiresSubscription" @change="ItemSearch()">Abonelik Ürünü</vs-radio>
              <vs-radio vs-value="false" vs-name="RequiresSubscription" v-model="searchModel.requiresSubscription" @change="ItemSearch()">Abonelik Ürünü Değil</vs-radio>
            </div>

            <div class="vx-col md:w-1/6 w-full" style="text-align: left;">
              <vs-radio vs-value="RawMaterial" vs-name="ProduceType" v-model="searchModel.ProduceType" @change="ItemSearch()">Hammadde</vs-radio>
              <vs-radio vs-value="Purchase" vs-name="ProduceType" v-model="searchModel.ProduceType" @change="ItemSearch()">Satın Alınan</vs-radio>
              <vs-radio vs-value="Produce" vs-name="ProduceType" v-model="searchModel.ProduceType" @change="ItemSearch()">Nitro Üretimi</vs-radio>
            </div>
            <vs-button hidden></vs-button>
          </div>
        </form>
        <div class="vx-row mt-2 w-full">
          <div class="vx-col w-full">
            <vs-table search :maxItems="10" :pagination="true" :data="resultList">
              <template slot="thead">
                <vs-th class="w-1/3">Ürün</vs-th>
                <vs-th class="w-1/6">Seç ve Kapat</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.customerId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.productName.substr(0, 30) + " ( ProductId : " + tr.productId + " )" }}
                  </vs-td>

                  <td class="flex">
                    <vs-button size="small" class="ml-3" color="primary" @click="ChooseOrClose(tr)">Seç</vs-button>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </template>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";

export default {
  components: {
    vSelect,
  },
  props: {
    productSearchPopupProp: null,
  },
  data() {
    return {
      userList: [],
      productBrandList: [],
      chosenItem: { productName: null, productId: null, brand: null, productType: null, requiresSubscription: null, produceType: null },
      searchModel: { brand: null, productName: null, productId: null },
      resultList: [],
      currenttype: "",
      searchQuery: "",
      activeDeviceFeatures: false,
      brandSearch: { brandName: null },
    };
  },
  computed: {
    productSearchPopupComputed: {
      get() {
        return this.productSearchPopupProp;
      },
      set() {},
    },
  },
  watch: {},
  methods: {
    ChooseOrClose: async function (item) {
      this.$emit("ProductSearchPopupClosedChildEmit", item);
    },
    delayedSearch: async function () {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(async () => {
        if (this.searchModel && this.searchModel.length > 2) {
          await this.ItemSearch();
        }
      }, 500);
    },

    ItemSearch: async function () {
      this.$vs.loading();

      this.resultList = await repository.postEntity("Product/GetProductDetail", this.searchModel).then((r) => r.list);
      this.$vs.loading.close();
    },
    getProductBrand: async function () {
      this.productBrandList = await repository.postEntity("Product/GetProductBrand", this.brandSearch).then((r) => r.list);
    },

    cancel() {},
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.ChooseOrClose();
      }
    });
  },
  created() {
    this.getProductBrand();
  },
};
</script>

<style lang="scss" scoped></style>
